//创建初始状态，导出一个函数
const defaultState = {
    address:'',
    pAddress:"",
    showLoading:false,
    isLogin:false,
    chain:'bsc',
    client_id:'',
    roomid:null,
    hisMessage:[],
    lan:'en',
    flash:false,
    isTiao:false,
}

//eslint-disable-next-line
export default (state=defaultState,action) => {
    let newState = JSON.parse(JSON.stringify(state))
    switch (action.type) {
        case "setAddress":
            newState.address=action.value;
            break;
        case "setPAddress":
            newState.pAddress=action.value;
            break;
        case "setShowLoading":
            newState.showLoading=action.value;
            break;
        case "setIsLogin":
            newState.isLogin=action.value;
            break;
        case "setChain":
            newState.chain=action.value;
            break;
        case "setclientId":
            newState.client_id=action.value;
            break;
        case "setRoomid":
            newState.roomid=action.value;
            break;
        case "setHisMessage":
            newState.hisMessage=action.value;
            break;
        case "setLan":
            newState.lan=action.value;
            break;
        case "setFlash":
            newState.flash=action.value;
            break;
        case "setIsTiao":
            newState.isTiao=action.value;
            break;
        default:
            break;
    }
    return newState;
}